module.exports = __webpack_public_path__ + "static/four-135ba2ff727d2a945bb942590023d0ff.png";